import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import firebase from "firebase/app";
import store from '@/store'
import vuetify from './plugins/vuetify';
import VueFirestore from 'vue-firestore';
import 'firebase/firestore'
import moment from 'moment'
import JsonCSV from 'vue-json-csv'

Vue.use(VueFirestore, {
  key: 'id',         // the name of the property. Default is '.key'.
  enumerable: true  //  whether it is enumerable or not. Default is true.
})

Vue.component('downloadCsv', JsonCSV)

Vue.config.productionTip = false

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm - DD/MM/YYYY')
  }
});


let app = '';
const config = {
  apiKey: "AIzaSyBLVU5AScB0Slnj8UcdxImDcy7YagsIV8k",
  authDomain: "fcv-broker.firebaseapp.com",
  projectId: "fcv-broker",
  storageBucket: "fcv-broker.appspot.com",
  messagingSenderId: "164184428061",
  appId: "1:164184428061:web:03886107981a0b66f040f4",
  measurementId: "G-MYWD6FK9FL"
};

let firebaseApp = firebase.initializeApp(config);
const firestore = firebaseApp.firestore();
const firestorage = firebaseApp.storage();
export const db = firestore;
export const storage = firestorage;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
  }
});
